"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalConfirmation = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDialog = require("@radix-ui/react-dialog");
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = require("../../Button");
var _Modal = require("../Modal");
var _IconButton = require("../../IconButton");
var _Icons = require("../../Icons");
var _ModalConfirmationModule = _interopRequireDefault(require("./ModalConfirmation.module.css"));
var _excluded = ["className", "children", "title", "cancelLabel", "confirmationLabel", "inProgress", "onCancel", "onConfirm"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var ModalConfirmation = _ref => {
  var className = _ref.className,
    children = _ref.children,
    title = _ref.title,
    cancelLabel = _ref.cancelLabel,
    confirmationLabel = _ref.confirmationLabel,
    inProgress = _ref.inProgress,
    onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Modal.Modal, _extends({
    className: (0, _classnames.default)(_ModalConfirmationModule.default.WiderContent, className)
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: _ModalConfirmationModule.default.Head,
    "data-testid": "modal-head"
  }, /*#__PURE__*/_react.default.createElement(_reactDialog.Title, {
    className: _ModalConfirmationModule.default.Title
  }, title), /*#__PURE__*/_react.default.createElement(_reactDialog.Close, {
    asChild: true,
    className: _ModalConfirmationModule.default.CloseIcon
  }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
    Icon: _Icons.IconXClose,
    onClick: onCancel
  }))), children, /*#__PURE__*/_react.default.createElement("div", {
    className: _ModalConfirmationModule.default.FooterActions,
    "data-testid": "modal-actions"
  }, /*#__PURE__*/_react.default.createElement(_reactDialog.Close, {
    asChild: true
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: _Button.Variant.Secondary,
    color: _Button.Color.Greyscale,
    onPress: onCancel,
    "data-testid": "modal-cancel-button"
  }, cancelLabel)), /*#__PURE__*/_react.default.createElement(_reactDialog.Close, {
    asChild: true
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    color: _Button.Color.Red,
    onPress: onConfirm,
    "data-testid": "modal-confirm-button",
    isLoading: inProgress
  }, confirmationLabel))));
};
exports.ModalConfirmation = ModalConfirmation;
//# sourceMappingURL=ModalConfirmation.js.map